import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { createTicket } from '../../../services/tickets';
import { ICreateTicketFormInitialValues } from '../../../pages/Tickets/types';

interface IProps {
  payload: ICreateTicketFormInitialValues;
}
export const ThunkCreateTicket = createAsyncThunk<{ data: string }, IProps>(
  `${storeResources.TICKETS}/createTicket`,
  ({ payload }) => createTicket(payload).then(res => res.data),
);
